export const pluginPrefix = 'PLUGIN:GARMIN_FISCAL:';
export const SHOULD_SAVE_TAX_INVOICE = `${pluginPrefix}SHOULD_SAVE_TAX_INVOICE`;
export const SET_CUSTOMER_DATA = `${pluginPrefix}SET_CUSTOMER_DATA`;
export const SET_DOCUMENT_TYPE = `${pluginPrefix}SET_DOCUMENT_TYPE`;
export const RESET_FISCAL_STATE = `${pluginPrefix}RESET_FISCAL_STATE`;